var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLikes = function SvgIconLikes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.01 17.383a.7.7 0 0 1-.142-.014.7.7 0 0 1-.378-.195l-6.04-6.041a.7.7 0 0 1-.089-.107 4.994 4.994 0 0 1 .104-6.944 4.996 4.996 0 0 1 6.538-.447 5 5 0 0 1 6.54.447 4.994 4.994 0 0 1 .1 6.946.7.7 0 0 1-.086.105l-6.04 6.041a.71.71 0 0 1-.506.21m-5.46-7.17 5.453 5.454 5.456-5.456a1 1 0 0 1 .079-.095 3.563 3.563 0 0 0-.006-5.024 3.563 3.563 0 0 0-5.025-.006.714.714 0 0 1-1.008 0 3.563 3.563 0 0 0-5.024.006 3.563 3.563 0 0 0-.006 5.024q.045.045.08.097"
  })));
};
export default SvgIconLikes;